<!--pop up notification-->

@if (!openedOverlay) {
  <div style="position: absolute; top: 48px; right: 24px; z-index:9999; background-color: var(--mat-sys-background)">
    @for (msg of notifications; track msg) {
      <phito-notification-popup-item
        @fadeInOut
        [notification]="msg"
        (closed)="closeNotification(msg)"
        >
      </phito-notification-popup-item>
    }
  </div>
}
